define('rebrush/components/product/options/engraving',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    $,
    Component,
    BEM
) {

    return Component.create({
        $init: function() {
            $('[data-engraving-block]').each(function() {
                var block               = $(this),
                    showLink            = block.find('[data-show-engraving-field]'),
                    removeLink          = block.find('[data-remove-engraving-field]'),
                    priceNotice         = block.parents('dd').prev('dt') .find('.price-notice'),
                    inputBox            = block.find('.input-box'),
                    input               = inputBox.find('input[type="text"]'),
                    maxCharactersBlock  = block.find('[data-max-characters]'),
                    previewBlock        = block.find('[data-engraving-preview]'),
                    saveEngravingButton = block.find('[data-save-engraving]'),
                    savedEngravingBlock = block.find('[data-saved-engraving]'),
                    maxCharacters       = maxCharactersBlock.data('max-characters'),
                    closeButton         = $('<a class="engraving-close" href="#">&times;</a>').hide(),
                    addToCartButton     = BEM.block('product-detail-add-to-cart').getElements('add-to-cart-button').first();

                closeButton.on('click', function (e) {
                    e.preventDefault();
                    closeButton.hide();
                    inputBox.hide();
                    showLink.show();
                    removeLink.hide();
                    savedEngravingBlock.hide();
                    savedEngravingBlock.html('');
                    previewBlock.html('');
                    maxCharactersBlock.html(maxCharacters);

                    if (input.val().length) {
                        input.val('');
                        input.trigger('change');
                        opConfig.reloadPrice();
                    }
                });

                input.on('change keyup', function(){
                    var elem = $(this);
                    previewBlock.html(elem.val());
                    savedEngravingBlock.html(elem.val());
                    maxCharactersBlock.html(parseInt(maxCharacters, 10) - elem.val().length);
                });

                input.on('change', function () {
                    if (input.val() === '') {
                        closeButton.trigger('click');
                        opConfig.reloadPrice();
                    }
                });

                priceNotice.append(closeButton);

                showLink.on('click', function(e){
                    e.preventDefault();
                    closeButton.show();
                    inputBox.show();
                    showLink.hide();
                });

                saveEngravingButton.on('click', function(e) {
                    e.preventDefault();
                    if (input.val().length) {
                        inputBox.hide();
                        closeButton.hide();
                        addToCartButton.attr('data-customprint-added', 1);
                        savedEngravingBlock.attr('data-saved-engraving', '1');
                        savedEngravingBlock.show();
                        removeLink.show();
                    }
                });

                savedEngravingBlock.on('click', function(e){
                    e.preventDefault();
                    inputBox.show();
                    closeButton.show();
                    savedEngravingBlock.attr('data-saved-engraving', '0');
                    addToCartButton.attr('data-customprint-added', 0);
                    savedEngravingBlock.hide();
                });

                removeLink.on('click', function(e){
                    e.preventDefault();
                    $(this).hide();
                    showLink.show();
                    input.val('');
                    savedEngravingBlock.hide();
                    savedEngravingBlock.attr('data-saved-engraving', '0');
                    savedEngravingBlock.html('');
                    addToCartButton.attr('data-customprint-added', 0);
                    input.trigger('change');
                    opConfig.reloadPrice();
                });

                if (input.val().length) {
                    input.trigger('change');
                    savedEngravingBlock.html(input.val());
                    savedEngravingBlock.show();
                    opConfig.reloadPrice();
                    showLink.hide();
                    removeLink.show();
                }
            });
        }
    });
});
